<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p>
        <span class="breadcrumb-item" @click="irInicio">{{ $t('panelCliente.inicio') }}</span> > {{ $t('panelCliente.titulo') }}
      </p>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="titulo">
            <h5 class="mx-4 mt-5 mb-3">{{ $t('panelCliente.titulo') }}</h5>
            <p class="mx-4 mb-4 text-sm opacity-7">
              {{ $t('panelCliente.subtitulo') }}
            </p>
          </div>
          <div class="selector-row px-4 pb-4">
            <div class="select-block" v-if="canAdmin">
              <label class="text-sm mb-2">{{ $t('panelCliente.cliente') }}</label>
              <div class="select-wrap">
                <select class="form-select" v-model="clienteId">
                  <option value="">{{ $t('panelCliente.miCuenta') }}</option>
                  <option v-for="c in clientes" :key="c.id" :value="String(c.id)">
                    {{ c.name }} ({{ c.email }})
                  </option>
                </select>
              </div>
              <div v-if="clientes.length === 0" class="mt-3 alert alert-secondary text-sm">
                {{ $t('panelCliente.cargandoClientes') }}
              </div>
            </div>

            <div class="selector-actions">
              <QBtn variant="tipster" :label="$t('panelCliente.actualizar')" :loading="loading" :disabled="loading" @click="cargarPanel" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <PanelClienteResumen
      :resumen="resumen"
      :cuenta="panel.cuenta"
      :loading="loading"
      :hay-datos="hayDatos"
    />
    <PanelClienteCuenta :cuenta="panel.cuenta" />
    <PanelClienteServiciosActivos :servicios="serviciosActivos" />
    <PanelClienteSuscripciones :suscripciones="suscripciones" :userEmail="panel.cuenta?.email || ''" @recargar="cargarPanel" />
    <PanelClienteHistorial :pedidos="historialPedidos" />
    <PanelClienteActividad :actividad="actividadCanales" />
  </div>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import PanelClienteResumen         from "./components/panel-cliente/PanelClienteResumen.vue";
import PanelClienteCuenta          from "./components/panel-cliente/PanelClienteCuenta.vue";
import PanelClienteServiciosActivos from "./components/panel-cliente/PanelClienteServiciosActivos.vue";
import PanelClienteSuscripciones   from "./components/panel-cliente/PanelClienteSuscripciones.vue";
import PanelClienteHistorial       from "./components/panel-cliente/PanelClienteHistorial.vue";
import PanelClienteActividad       from "./components/panel-cliente/PanelClienteActividad.vue";

export default {
  name: "PanelCliente",
  components: {
    PanelClienteResumen,
    PanelClienteCuenta,
    PanelClienteServiciosActivos,
    PanelClienteSuscripciones,
    PanelClienteHistorial,
    PanelClienteActividad,
  },
  data() {
    return {
      loading: false,
      clienteId: "",
      clientes: [],
      panel: {
        cuenta: null,
        resumen: {},
        servicios_activos: [],
        suscripciones: [],
        historial_pedidos: [],
        actividad_canales: [],
      },
    };
  },
  computed: {
    permisos() { return this.$store.state.auth?.permisos_finales || []; },
    canAdmin() { return Array.isArray(this.permisos) && this.permisos.includes("cliente.dashboard.admin.ver"); },
    resumen() { return this.panel?.resumen || {}; },
    serviciosActivos() { return Array.isArray(this.panel?.servicios_activos) ? this.panel.servicios_activos : []; },
    suscripciones() { return Array.isArray(this.panel?.suscripciones) ? this.panel.suscripciones : []; },
    historialPedidos() { return Array.isArray(this.panel?.historial_pedidos) ? this.panel.historial_pedidos : []; },
    actividadCanales() { return Array.isArray(this.panel?.actividad_canales) ? this.panel.actividad_canales : []; },
    hayDatos() {
      return (
        (this.resumen.total_pedidos ?? 0) > 0 ||
        this.serviciosActivos.length > 0 ||
        this.historialPedidos.length > 0 ||
        this.actividadCanales.length > 0
      );
    },
  },
  watch: {
    canAdmin: {
      immediate: true,
      handler(n) { if (n) this.cargarClientesAdmin(); },
    },
  },
  methods: {
    irInicio() { this.$router.push("/dashboard"); },
    async cargarClientesAdmin() {
      try {
        const resp = await this.$store.dispatch("auth/listaClientesAdmin");
        const arr = Array.isArray(resp?.data) ? resp.data : (Array.isArray(resp) ? resp : []);
        this.clientes = arr;
      } catch (e) {
        console.error(e);
      }
    },
    resolveClienteId() {
      if (this.clienteId) return Number(this.clienteId);
      return null;
    },
    async cargarPanel() {
      this.loading = true;
      try {
        let resp;
        if (this.canAdmin && this.clienteId) {
          resp = await this.$store.dispatch("auth/clientePanelAdmin", { userId: Number(this.clienteId), payload: {} });
        } else {
          resp = await this.$store.dispatch("auth/clientePanel", {});
        }
        const data = resp?.data?.attributes ?? resp?.data ?? resp?.attributes ?? resp;
        this.panel = {
          cuenta: data?.cuenta || null,
          resumen: data?.resumen || {},
          servicios_activos: data?.servicios_activos || [],
          suscripciones: data?.suscripciones || [],
          historial_pedidos: data?.historial_pedidos || [],
          actividad_canales: data?.actividad_canales || [],
        };
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: this.$t('panelCliente.errorCargar'), width: 520 });
        this.panel = { cuenta: null, resumen: {}, servicios_activos: [], suscripciones: [], historial_pedidos: [], actividad_canales: [] };
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.$store.commit('setShowFooter', true);
    await this.cargarPanel();
  },
};
</script>

<style scoped>
.container-fluid { max-width: 1100px; }
.selector-row { display: flex; gap: 16px; align-items: flex-end; flex-wrap: wrap; }
.selector-actions { margin-left: auto; display: flex; gap: 10px; flex-wrap: wrap; align-items: flex-end; }

.select-block { display: flex; flex-direction: column; gap: 6px; min-width: 260px; max-width: 360px; }
.select-block label { font-size: 12px; font-weight: 600; color: var(--q-text-muted); text-transform: uppercase; letter-spacing: .05em; margin: 0; }
.select-wrap { position: relative; }
.select-wrap .form-select {
  background-color: var(--q-card-alt);
  color: var(--q-text);
  border: 1px solid var(--q-border-md);
  border-radius: 10px;
  padding: 8px 36px 8px 12px;
  font-size: 14px;
  font-weight: 500;
  appearance: none;
  width: 100%;
  cursor: pointer;
}
.select-wrap .form-select:focus { outline: none; border-color: var(--q-gold); box-shadow: 0 0 0 2px rgba(245,166,35,.15); }
.select-wrap::after {
  content: "▼";
  position: absolute;
  right: 12px; top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  color: var(--q-gold);
  pointer-events: none;
}

@media (max-width: 600px) {
  .selector-row { flex-direction: column; align-items: stretch; }
  .selector-actions { margin-left: 0; }
  .select-block { max-width: 100%; }
}
</style>
